import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { PureComponent } from 'react';
// eslint-disable-next-line @repo/internal/react/no-class-components
var HtmlContent = /*#__PURE__*/function (_PureComponent) {
  function HtmlContent() {
    _classCallCheck(this, HtmlContent);
    return _callSuper(this, HtmlContent, arguments);
  }
  _inherits(HtmlContent, _PureComponent);
  return _createClass(HtmlContent, [{
    key: "render",
    value: function render() {
      var html = this.props.html;
      return /*#__PURE__*/React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: html
        }
      });
    }
  }]);
}(PureComponent);
export { HtmlContent as default };